module.exports = __webpack_public_path__ + "static/media/align-v-center.c7f6a87b.svg";